<template>
  <v-container class="login-view">
    <page-title :title="$t('auth.login.page_title')"></page-title>
    <h1 class="title" v-html="$t('auth.login.section_title')"></h1>
    <form action="/login" @submit.prevent="submit" class="login-form">
      <v-layout column>
        <v-flex class="text-input-container">
          <label> {{ $t('email') }} </label>
          <v-text-field
            class="lg-text-field"
            v-model="formData.username"
            autocomplete="username"
            solo
            v-validate="'required|email|max:50'"
            :error-messages="errors.collect('username')"
            data-vv-name="username"
            counter="50"
          ></v-text-field>
        </v-flex>
        <v-flex class="text-input-container">
          <label> {{ $t('password') }} </label>
          <v-text-field
            class="lg-text-field"
            v-model="formData.password"
            solo
            type="password"
            name="password"
            autocomplete="current-password"
            v-validate="'required|min:8'"
            :error-messages="errors.collect('password')"
            data-vv-name="password"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout justify-end>
        <router-link class="link" to="forgot">{{
          $t('auth.forgot.section_title')
        }}</router-link>
      </v-layout>
      <v-layout row justify-center>
        <v-btn
          color="primary"
          type="submit"
          :loading="submitLoading"
          depressed
          round
          large
          >{{ $t('submit') }}</v-btn
        >
      </v-layout>
    </form>
    <TwoColumnBottomAction>
      {{ $t('auth.login.dont_have_account') }}
      <router-link class="link" to="signup">{{
        $t('auth.signup.page_title')
      }}</router-link>
    </TwoColumnBottomAction>
  </v-container>
</template>

<script>
import formMixins from '@/mixins/forms'
import TwoColumnBottomAction from '@/components/auth/TwoColumnBottomAction.vue'
import routes from '@/route_names'
export default {
  name: 'Login',
  mixins: [formMixins],
  components: { TwoColumnBottomAction },
  created: function() {},
  data: function() {
    return {
      formData: {
        username: '',
        password: ''
      }
    }
  },
  computed: {},
  methods: {
    init: function() {},
    load: function() {},
    refresh: function() {},

    getFormSubmitPromise: function() {
      const vm = this
      return this.$store
        .dispatch('user/login', this.formData)
        .then(function(res) {
          if(vm.$router.currentRoute.query.next){
            window.location = vm.$router.currentRoute.query.next
          }
          else {
            vm.$router.push({
              name: routes.APP
            })
          }
          
        })
    }
  }
}
</script>

<style lang="stylus">
@require "common.styl"
.login-view {
    h1 {
        margin-bottom 30px
        color: var(--v-primary-base)
    }
}
.login-form {
    max-width: 350px;
    margin auto
}
</style>
